module.exports = __webpack_public_path__ + "static/img/btn1.55c3803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/btn1.png
// module id = isZA
// module chunks = 0